import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useLoading } from '../../../context/useLoading'
import Assessments from './Assessments'
import WithMainLayout from '../../../hocs/withMainLayout'
import Loading from '../../shared/Loading'
import { axiosKazlingoFormData } from '../../../utils/axiosKazlingo'
import { ASSESSMENT_T } from './enum'
import {
  EN_ARRAY_FIELDS,
  EN_STRING_FIELDS,
  cleanVariantsEn
} from './forms/EnglishFields'

const arrayFields = [
  'storyQuestions',
  'variants',
  'column1',
  'column2',
  'correctMatches',
  'correctVariants'
]

export const processAssessmentData = (formData, values) => {
  Object.keys(values).forEach(key => {
    if (arrayFields.includes(key) !== -1) {
      formData.append(key, values[key])
    }
  })
  switch (values.type) {
    case ASSESSMENT_T.matchWords:
      formData.set('column1', JSON.stringify(values.column1))
      formData.set('column2', JSON.stringify(values.column2))
      formData.set('correctMatches', JSON.stringify(values.correctMatches))
      break
    case ASSESSMENT_T.qonzhyqStories:
      const storyQuestions = []
      values.storyQuestions.forEach(variant => {
        const { correctText, variants: inVariants, type } = variant
        storyQuestions.push({ type, correctText, variants: inVariants })
      })
      formData.set('storyQuestions', JSON.stringify(storyQuestions))
      break
    case ASSESSMENT_T.translateSentence:
      formData.set('correctVariants', JSON.stringify(values.correctVariants))
      break
    default:
      break
  }

  // EN-поля (общие для всех типов). Пустые не шлём, массивы — JSON, как column1/variants
  EN_STRING_FIELDS.forEach(key => {
    if (values[key] === undefined || values[key] === null) formData.delete(key)
  })
  EN_ARRAY_FIELDS.forEach(key => {
    const value =
      key === 'variantsEn' ? cleanVariantsEn(values[key]) : values[key]
    if (Array.isArray(value) && value.length) {
      formData.set(key, JSON.stringify(value))
    } else {
      formData.delete(key)
    }
  })

  if (values.variants) {
    const variants = []
    values.variants.forEach(variant => {
      const { text, isCorrect, correctIndex, imageFile, textEn } = variant
      // перевод варианта едет вместе с ним (variants[].textEn)
      const en = textEn ? { textEn } : {}
      switch (values.type) {
        case ASSESSMENT_T.chooseCorrectPicture:
          variants.push({ text, isCorrect, ...en })
          formData.append('variantsFileArray', imageFile || new Blob([]))
          break
        case ASSESSMENT_T.whatDidYouHear:
        case ASSESSMENT_T.chooseCorrectTranslation:
        case ASSESSMENT_T.chooseCorrectAnswer:
        case ASSESSMENT_T.answerQuestion:
        case ASSESSMENT_T.answerQuestionImage:
          variants.push({ text, isCorrect, ...en })
          break
        case ASSESSMENT_T.translateSentence:
        case ASSESSMENT_T.listenAudioCreateSentence:
        case ASSESSMENT_T.listenAudioFinishSentence:
        case ASSESSMENT_T.fillBlankSpace:
          variants.push({ text, correctIndex, ...en })
          break
        default:
          break
      }
    })
    formData.set('variants', JSON.stringify(variants))
  }
}

const AssessmentsContainer = () => {
  const { showLoading, hideLoading } = useLoading()
  const [allAssessments, setAllAssessments] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  useEffect(() => {
    const fetchAssessments = async () => {
      try {
        const { data } = await axiosKazlingoFormData.get('/assessments')
        setAllAssessments(data)
      } catch (error) {
        setError(error)
        toast.error('Ошибка при загрузке')
      } finally {
        setLoading(false)
      }
    }
    fetchAssessments()
  }, [])

  const addAssessmentHandler = async (form, closeFunc) => {
    try {
      form.validateFields().then(async values => {
        form.resetFields()
        showLoading()
        const formData = new FormData()
        processAssessmentData(formData, values)
        const { data: newAssessment } = await axiosKazlingoFormData.post(
          '/assessments/' + values.type,
          formData
        )
        setAllAssessments([...allAssessments, newAssessment])
        toast.success('Задача добавлена')
        hideLoading()
      })
    } catch (error) {
      console.error('Ошибка при добавлении задачи:', error)
      toast.error('Ошибка при добавлении задачи')
    } finally {
      hideLoading()
      closeFunc(false)
    }
  }

  const updateAssessmentHandler = async (id, form, closeFunc) => {
    try {
      form.validateFields().then(async values => {
        showLoading()
        const formData = new FormData()
        processAssessmentData(formData, values)
        const { data: updatedAssessment } = await axiosKazlingoFormData.put(
          `/assessments/${values.type}/${id}`,
          formData
        )
        setAllAssessments(
          allAssessments.map(a => (a._id === id ? updatedAssessment : a))
        )
        toast.success('Задача обновлена')
        form.resetFields()
        hideLoading()
      })
    } catch (error) {
      console.error('Ошибка при обновлении задачи:', error)
      toast.error('Ошибка при обновлении задачи')
    } finally {
      hideLoading()
      closeFunc(false)
    }
  }

  const deleteAssessmentHandler = async (id, closeFunc) => {
    try {
      showLoading()
      await axiosKazlingoFormData.delete(`/assessments/${id}`)
      setAllAssessments(allAssessments.filter(a => a._id !== id))
      toast.success('Задача удалена')
      hideLoading()
    } catch (error) {
      console.error('Ошибка при удалении задачи:', error)
      toast.error('Ошибка при удалении задачи')
    } finally {
      hideLoading()
      closeFunc(false)
    }
  }

  if (loading) {
    return <Loading />
  }

  if (error) {
    return <div>Ошибка при загрузке задачи</div>
  }

  return (
    <Assessments
      assessments={allAssessments}
      createHandler={addAssessmentHandler}
      updateHandler={updateAssessmentHandler}
      deleteHandler={deleteAssessmentHandler}
    />
  )
}

export default WithMainLayout(AssessmentsContainer)
